const breedIllustrations: Record<string, string> = {
  affenpinscher: "/images/breeds-pencil/affenpinscher-photo-ref.png",
  "afghan-hound": "/images/breeds-pencil/afghan-hound-photo-ref.png",
  "airedale-terrier": "/images/breeds-pencil/airedale-terrier-photo-ref.png",
  akita: "/images/breeds-pencil/akita-photo-ref.png",
  "alaskan-malamute": "/images/breeds-pencil/alaskan-malamute-photo-ref.png",
  "american-english-coonhound": "/images/breeds-pencil/american-english-coonhound-photo-ref.png",
  "american-eskimo-dog": "/images/breeds-pencil/american-eskimo-dog-photo-ref.png",
  "american-foxhound": "/images/breeds-pencil/american-foxhound-photo-ref.png",
  "american-hairless-terrier": "/images/breeds-pencil/american-hairless-terrier-photo-ref.png",
  "american-staffordshire-terrier": "/images/breeds-pencil/american-staffordshire-terrier-photo-ref.png",
  "american-water-spaniel": "/images/breeds-pencil/american-water-spaniel-photo-ref.png",
  "anatolian-shepherd-dog": "/images/breeds-pencil/anatolian-shepherd-dog-photo-ref.png",
  "australian-cattle-dog": "/images/breeds-pencil/australian-cattle-dog-photo-ref.png",
  "australian-shepherd": "/images/breeds-pencil/australian-shepherd-photo-ref.png",
  "australian-terrier": "/images/breeds-pencil/australian-terrier-photo-ref.png",
  azawakh: "/images/breeds-pencil/azawakh-photo-ref.png",
  barbet: "/images/breeds-pencil/barbet-photo-ref.png",
  basenji: "/images/breeds-pencil/basenji-photo-ref.png",
  "basset-fauve-de-bretagne": "/images/breeds-pencil/basset-fauve-de-bretagne-photo-ref.png",
  "basset-hound": "/images/breeds-pencil/basset-hound-photo-ref.png",
  "bearded-collie": "/images/breeds-pencil/bearded-collie-photo-ref.png",
  beauceron: "/images/breeds-pencil/beauceron-photo-ref.png",
  "bedlington-terrier": "/images/breeds-pencil/bedlington-terrier-photo-ref.png",
  "belgian-laekenois": "/images/breeds-pencil/belgian-laekenois-photo-ref.png",
  "belgian-malinois": "/images/breeds-pencil/belgian-malinois-photo-ref.png",
  "belgian-sheepdog": "/images/breeds-pencil/belgian-sheepdog-photo-ref.png",
  "belgian-tervuren": "/images/breeds-pencil/belgian-tervuren-photo-ref.png",
  "bergamasco-sheepdog": "/images/breeds-pencil/bergamasco-sheepdog-photo-ref.png",
  "berger-picard": "/images/breeds-pencil/berger-picard-photo-ref.png",
  "bernese-mountain-dog": "/images/breeds-pencil/bernese-mountain-dog-photo-ref.png",
  "bichon-frise": "/images/breeds-pencil/bichon-frise-photo-ref.png",
  "biewer-terrier": "/images/breeds-pencil/biewer-terrier-photo-ref.png",
  "black-and-tan-coonhound": "/images/breeds-pencil/black-and-tan-coonhound-photo-ref.png",
  "black-russian-terrier": "/images/breeds-pencil/black-russian-terrier-photo-ref.png",
  bloodhound: "/images/breeds-pencil/bloodhound-photo-ref.png",
  "bluetick-coonhound": "/images/breeds-pencil/bluetick-coonhound-photo-ref.png",
  boerboel: "/images/breeds-pencil/boerboel-photo-ref.png",
  "border-collie": "/images/breeds-pencil/border-collie-photo-ref.png",
  "border-terrier": "/images/breeds-pencil/border-terrier-photo-ref.png",
  borzoi: "/images/breeds-pencil/borzoi-photo-ref.png",
  "boston-terrier": "/images/breeds-pencil/boston-terrier-photo-ref.png",
  "bouvier-des-flandres": "/images/breeds-pencil/bouvier-des-flandres-photo-ref.png",
  boxer: "/images/breeds-pencil/boxer-photo-ref.png",
  "boykin-spaniel": "/images/breeds-pencil/boykin-spaniel-photo-ref.png",
  "bracco-italiano": "/images/breeds-pencil/bracco-italiano-photo-ref.png",
  briard: "/images/breeds-pencil/briard-photo-ref.png",
  brittany: "/images/breeds-pencil/brittany-photo-ref.png",
  "brussels-griffon": "/images/breeds-pencil/brussels-griffon-photo-ref.png",
  "bull-terrier": "/images/breeds-pencil/bull-terrier-photo-ref.png",
  bullmastiff: "/images/breeds-pencil/bullmastiff-photo-ref.png",
  "cairn-terrier": "/images/breeds-pencil/cairn-terrier-photo-ref.png",
  "canaan-dog": "/images/breeds-pencil/canaan-dog-photo-ref.png",
  "cardigan-welsh-corgi": "/images/breeds-pencil/cardigan-welsh-corgi-photo-ref.png",
  "cesky-terrier": "/images/breeds-pencil/cesky-terrier-photo-ref.png",
  "chesapeake-bay-retriever": "/images/breeds-pencil/chesapeake-bay-retriever-photo-ref.png",
  chihuahua: "/images/breeds-pencil/chihuahua-photo-ref.png",
  "chinese-crested": "/images/breeds-pencil/chinese-crested-photo-ref.png",
  "chinese-shar-pei": "/images/breeds-pencil/chinese-shar-pei-photo-ref.png",
  chinook: "/images/breeds-pencil/chinook-photo-ref.png",
  "chow-chow": "/images/breeds-pencil/chow-chow-photo-ref.png",
  "cirneco-delletna": "/images/breeds-pencil/cirneco-delletna-photo-ref.png",
  "clumber-spaniel": "/images/breeds-pencil/clumber-spaniel-photo-ref.png",
  "cocker-spaniel": "/images/breeds-pencil/cocker-spaniel-photo-ref.png",
  collie: "/images/breeds-pencil/collie-photo-ref.png",
  "coton-de-tulear": "/images/breeds-pencil/coton-de-tulear-photo-ref.png",
  "curly-coated-retriever": "/images/breeds-pencil/curly-coated-retriever-photo-ref.png",
  dalmatian: "/images/breeds-pencil/dalmatian-photo-ref.png",
  "dandie-dinmont-terrier": "/images/breeds-pencil/dandie-dinmont-terrier-photo-ref.png",
  "danish-swedish-farmdog": "/images/breeds-pencil/danish-swedish-farmdog-photo-ref.png",
  "doberman-pinscher": "/images/breeds-pencil/doberman-pinscher-photo-ref.png",
  "dogo-argentino": "/images/breeds-pencil/dogo-argentino-photo-ref.png",
  "dogue-de-bordeaux": "/images/breeds-pencil/dogue-de-bordeaux-photo-ref.png",
  "english-cocker-spaniel": "/images/breeds-pencil/english-cocker-spaniel-photo-ref.png",
  "english-foxhound": "/images/breeds-pencil/english-foxhound-photo-ref.png",
  "english-setter": "/images/breeds-pencil/english-setter-photo-ref.png",
  "english-springer-spaniel": "/images/breeds-pencil/english-springer-spaniel-photo-ref.png",
  "english-toy-spaniel": "/images/breeds-pencil/english-toy-spaniel-photo-ref.png",
  "entlebucher-mountain-dog": "/images/breeds-pencil/entlebucher-mountain-dog-photo-ref.png",
  "field-spaniel": "/images/breeds-pencil/field-spaniel-photo-ref.png",
  "finnish-lapphund": "/images/breeds-pencil/finnish-lapphund-photo-ref.png",
  "finnish-spitz": "/images/breeds-pencil/finnish-spitz-photo-ref.png",
  "flat-coated-retriever": "/images/breeds-pencil/flat-coated-retriever-photo-ref.png",
  "german-pinscher": "/images/breeds-pencil/german-pinscher-photo-ref.png",
  "german-wirehaired-pointer": "/images/breeds-pencil/german-wirehaired-pointer-photo-ref.png",
  "giant-schnauzer": "/images/breeds-pencil/giant-schnauzer-photo-ref.png",
  "glen-of-imaal-terrier": "/images/breeds-pencil/glen-of-imaal-terrier-photo-ref.png",
  "gordon-setter": "/images/breeds-pencil/gordon-setter-photo-ref.png",
  "grand-basset-griffon-vendeen": "/images/breeds-pencil/grand-basset-griffon-vendeen-photo-ref.png",
  "great-dane": "/images/breeds-pencil/great-dane-photo-ref.png",
  "great-pyrenees": "/images/breeds-pencil/great-pyrenees-photo-ref.png",
  "greater-swiss-mountain-dog": "/images/breeds-pencil/greater-swiss-mountain-dog-photo-ref.png",
  greyhound: "/images/breeds-pencil/greyhound-photo-ref.png",
  harrier: "/images/breeds-pencil/harrier-photo-ref.png",
  havanese: "/images/breeds-pencil/havanese-photo-ref.png",
  "ibizan-hound": "/images/breeds-pencil/ibizan-hound-photo-ref.png",
  "icelandic-sheepdog": "/images/breeds-pencil/icelandic-sheepdog-photo-ref.png",
  "irish-red-and-white-setter": "/images/breeds-pencil/irish-red-and-white-setter-photo-ref.png",
  "irish-setter": "/images/breeds-pencil/irish-setter-photo-ref.png",
  "irish-terrier": "/images/breeds-pencil/irish-terrier-photo-ref.png",
  "irish-water-spaniel": "/images/breeds-pencil/irish-water-spaniel-photo-ref.png",
  "irish-wolfhound": "/images/breeds-pencil/irish-wolfhound-photo-ref.png",
  "italian-greyhound": "/images/breeds-pencil/italian-greyhound-photo-ref.png",
  "japanese-chin": "/images/breeds-pencil/japanese-chin-photo-ref.png",
  "keeshond": "/images/breeds-pencil/keeshond-photo-ref.png",
  "kerry-blue-terrier": "/images/breeds-pencil/kerry-blue-terrier-photo-ref.png",
  "komondor": "/images/breeds-pencil/komondor-photo-ref.png",
  "kuvasz": "/images/breeds-pencil/kuvasz-photo-ref.png",
  "lagotto-romagnolo": "/images/breeds-pencil/lagotto-romagnolo-photo-ref.png",
  "lakeland-terrier": "/images/breeds-pencil/lakeland-terrier-photo-ref.png",
  "lancashire-heeler": "/images/breeds-pencil/lancashire-heeler-photo-ref.png",
  "leonberger": "/images/breeds-pencil/leonberger-photo-ref.png",
  "lhasa-apso": "/images/breeds-pencil/lhasa-apso-photo-ref.png",
  "lowchen": "/images/breeds-pencil/lowchen-photo-ref.png",
  "maltese": "/images/breeds-pencil/maltese-photo-ref.png",
  "manchester-terrier": "/images/breeds-pencil/manchester-terrier-photo-ref.png",
  "mastiff": "/images/breeds-pencil/mastiff-photo-ref.png",
  "miniature-american-shepherd": "/images/breeds-pencil/miniature-american-shepherd-photo-ref.png",
  "miniature-bull-terrier": "/images/breeds-pencil/miniature-bull-terrier-photo-ref.png",
  "miniature-pinscher": "/images/breeds-pencil/miniature-pinscher-photo-ref.png",
  "miniature-schnauzer": "/images/breeds-pencil/miniature-schnauzer-photo-ref.png",
  "mudi": "/images/breeds-pencil/mudi-photo-ref.png",
  "neapolitan-mastiff": "/images/breeds-pencil/neapolitan-mastiff-photo-ref.png",
  "nederlandse-kooikerhondje": "/images/breeds-pencil/nederlandse-kooikerhondje-photo-ref.png",
  "newfoundland": "/images/breeds-pencil/newfoundland-photo-ref.png",
  "norfolk-terrier": "/images/breeds-pencil/norfolk-terrier-photo-ref.png",
  "norwegian-buhund": "/images/breeds-pencil/norwegian-buhund-photo-ref.png",
  "norwegian-elkhound": "/images/breeds-pencil/norwegian-elkhound-photo-ref.png",
  "norwegian-lundehund": "/images/breeds-pencil/norwegian-lundehund-photo-ref.png",
  "norwich-terrier": "/images/breeds-pencil/norwich-terrier-photo-ref.png",
  "nova-scotia-duck-tolling-retriever": "/images/breeds-pencil/nova-scotia-duck-tolling-retriever-photo-ref.png",
  "old-english-sheepdog": "/images/breeds-pencil/old-english-sheepdog-photo-ref.png",
  "otterhound": "/images/breeds-pencil/otterhound-photo-ref.png",
  "papillon": "/images/breeds-pencil/papillon-photo-ref.png",
  "parson-russell-terrier": "/images/breeds-pencil/parson-russell-terrier-photo-ref.png",
  "pekingese": "/images/breeds-pencil/pekingese-photo-ref.png",
  "pembroke-welsh-corgi": "/images/breeds-pencil/pembroke-welsh-corgi-photo-ref.png",
  "petit-basset-griffon-vendeen": "/images/breeds-pencil/petit-basset-griffon-vendeen-photo-ref.png",
  "pharaoh-hound": "/images/breeds-pencil/pharaoh-hound-photo-ref.png",
  "plott-hound": "/images/breeds-pencil/plott-hound-photo-ref.png",
  "pointer": "/images/breeds-pencil/pointer-photo-ref.png",
  "polish-lowland-sheepdog": "/images/breeds-pencil/polish-lowland-sheepdog-photo-ref.png",
  pomeranian: "/images/breeds-pencil/pomeranian-photo-ref.png",
  "portuguese-podengo-pequeno": "/images/breeds-pencil/portuguese-podengo-pequeno-photo-ref.png",
  "portuguese-water-dog": "/images/breeds-pencil/portuguese-water-dog-photo-ref.png",
  pug: "/images/breeds-pencil/pug-photo-ref.png",
  puli: "/images/breeds-pencil/puli-photo-ref.png",
  pumi: "/images/breeds-pencil/pumi-photo-ref.png",
  "pyrenean-shepherd": "/images/breeds-pencil/pyrenean-shepherd-photo-ref.png",
  "rat-terrier": "/images/breeds-pencil/rat-terrier-photo-ref.png",
  "redbone-coonhound": "/images/breeds-pencil/redbone-coonhound-photo-ref.png",
  "rhodesian-ridgeback": "/images/breeds-pencil/rhodesian-ridgeback-photo-ref.png",
  "russell-terrier": "/images/breeds-pencil/russell-terrier-photo-ref.png",
  "russian-toy": "/images/breeds-pencil/russian-toy-photo-ref.png",
  "russian-tsvetnaya-bolonka": "/images/breeds-pencil/russian-tsvetnaya-bolonka-photo-ref.png",
  "saint-bernard": "/images/breeds-pencil/saint-bernard-photo-ref.png",
  "saluki": "/images/breeds-pencil/saluki-photo-ref.png",
  "samoyed": "/images/breeds-pencil/samoyed-photo-ref.png",
  "schipperke": "/images/breeds-pencil/schipperke-photo-ref.png",
  "scottish-deerhound": "/images/breeds-pencil/scottish-deerhound-photo-ref.png",
  "scottish-terrier": "/images/breeds-pencil/scottish-terrier-photo-ref.png",
  "sealyham-terrier": "/images/breeds-pencil/sealyham-terrier-photo-ref.png",
  "shetland-sheepdog": "/images/breeds-pencil/shetland-sheepdog-photo-ref.png",
  "shiba-inu": "/images/breeds-pencil/shiba-inu-photo-ref.png",
  "shih-tzu": "/images/breeds-pencil/shih-tzu-photo-ref.png",
  "siberian-husky": "/images/breeds-pencil/siberian-husky-photo-ref.png",
  "silky-terrier": "/images/breeds-pencil/silky-terrier-photo-ref.png",
  "skye-terrier": "/images/breeds-pencil/skye-terrier-photo-ref.png",
  "sloughi": "/images/breeds-pencil/sloughi-photo-ref.png",
  "smooth-fox-terrier": "/images/breeds-pencil/smooth-fox-terrier-photo-ref.png",
  "soft-coated-wheaten-terrier": "/images/breeds-pencil/soft-coated-wheaten-terrier-photo-ref.png",
  "spanish-water-dog": "/images/breeds-pencil/spanish-water-dog-photo-ref.png",
  "spinone-italiano": "/images/breeds-pencil/spinone-italiano-photo-ref.png",
  "staffordshire-bull-terrier": "/images/breeds-pencil/staffordshire-bull-terrier-photo-ref.png",
  "standard-schnauzer": "/images/breeds-pencil/standard-schnauzer-photo-ref.png",
  "sussex-spaniel": "/images/breeds-pencil/sussex-spaniel-photo-ref.png",
  "swedish-vallhund": "/images/breeds-pencil/swedish-vallhund-photo-ref.png",
  "teddy-roosevelt-terrier": "/images/breeds-pencil/teddy-roosevelt-terrier-photo-ref.png",
  "tibetan-mastiff": "/images/breeds-pencil/tibetan-mastiff-photo-ref.png",
  "tibetan-spaniel": "/images/breeds-pencil/tibetan-spaniel-photo-ref.png",
  "tibetan-terrier": "/images/breeds-pencil/tibetan-terrier-photo-ref.png",
  "toy-fox-terrier": "/images/breeds-pencil/toy-fox-terrier-photo-ref.png",
  "treeing-walker-coonhound": "/images/breeds-pencil/treeing-walker-coonhound-photo-ref.png",
  "vizsla": "/images/breeds-pencil/vizsla-photo-ref.png",
  "weimaraner": "/images/breeds-pencil/weimaraner-photo-ref.png",
  "welsh-springer-spaniel": "/images/breeds-pencil/welsh-springer-spaniel-photo-ref.png",
  "welsh-terrier": "/images/breeds-pencil/welsh-terrier-photo-ref.png",
  "west-highland-white-terrier": "/images/breeds-pencil/west-highland-white-terrier-photo-ref.png",
  "whippet": "/images/breeds-pencil/whippet-photo-ref.png",
  "wire-fox-terrier": "/images/breeds-pencil/wire-fox-terrier-photo-ref.png",
  "wirehaired-pointing-griffon": "/images/breeds-pencil/wirehaired-pointing-griffon-photo-ref.png",
  "wirehaired-vizsla": "/images/breeds-pencil/wirehaired-vizsla-photo-ref.png",
  "yorkshire-terrier": "/images/breeds-pencil/yorkshire-terrier-photo-ref.png",
  beagle: "/images/breeds-pencil/beagle-photo-ref.png",
  bulldog: "/images/breeds-pencil/bulldog-photo-ref.png",
  "cane-corso": "/images/breeds-pencil/cane-corso-photo-ref.png",
  "cavalier-king-charles-spaniel": "/images/breeds-pencil/cavalier-king-charles-spaniel-photo-ref.png",
  dachshund: "/images/breeds-pencil/dachshund-photo-ref.png",
  "french-bulldog": "/images/breeds-pencil/french-bulldog-photo-ref.png",
  "german-shepherd-dog": "/images/breeds-pencil/german-shepherd-dog-photo-ref.png",
  "german-shorthaired-pointer": "/images/breeds-pencil/german-shorthaired-pointer-photo-ref.png",
  "golden-retriever": "/images/breeds-pencil/golden-retriever-photo-ref.png",
  "labrador-retriever": "/images/breeds-pencil/labrador-retriever-photo-ref.png",
  poodle: "/images/breeds-pencil/poodle-photo-ref.png",
  rottweiler: "/images/breeds-pencil/rottweiler-photo-ref.png",
  xoloitzcuintli: "/images/breeds-pencil/xoloitzcuintli-photo-ref.png",
};

export function getBreedIllustration(slug: string) {
  return breedIllustrations[slug];
}
